import {useRef} from "react";
import {Group, Mesh} from "three";
import {Line} from "@react-three/drei"


const Crosshair = (props: JSX.IntrinsicElements["group"]) => {
    const dot = useRef<Mesh>(null!);
    const lines = useRef<Group>(null!);

    return (
        <group {...props}>
            <group ref={lines}>
                <Line lineWidth={1} points={[[.05, 0, 0], [-.05, 0, 0]]}/>
                <Line lineWidth={1} points={[[0, .05, 0], [0, -.05, 0]]}/>
                <Line lineWidth={1} points={[[-.05, 0, 0], [-.05, 0, 0]]}/>
                <Line lineWidth={1} points={[[0, -.05, 0], [0, -.05, 0]]}/>
            </group>
            <mesh ref={dot}>
                <sphereBufferGeometry args={[0.0005, 64, 32]}/>
                <meshBasicMaterial color={'red'}/>
            </mesh>
        </group>
    )
}

export default Crosshair;